module.exports = __webpack_public_path__ + "img/case_bottom_003.68e2e739.png";